export const testCaseTableColumns: any = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
      width: "5%",
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
  },
  {
    display_name: "Test Case ID",
    key: "testCaseId",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
    _config: {
      type: "row-click",
      isClickable: "true",
      displayInColumn: false,
    },
  },
  {
    display_name: "Test Case",
    key: "testCase",
    headerStyles: {
      background: "#7593F2",
      width: "45%",
    },
    _config: {
      displayInColumn: false,
      type: "row-click",
      isClickable: "true",
      headerIcon: {
        type: "filter",
        iconPath: "assets/images/virtusa-icons/filter.svg",
        tooltip: "Filter"
      }
    },
  }
];

export const testCaseVersionTableColumns: any = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
      width: "5%",
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
  },
  {
    display_name: "Test Case ID",
    key: "testCaseId",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
    _config: {
      type: "row-click",
      isClickable: "true",
      displayInColumn: false,
    },
  },
  {
    display_name: "Test Case",
    key: "testCase",
    headerStyles: {
      background: "#7593F2",
      width: "45%",
    },
    _config: {
      type: "row-click",
      isClickable: "true",
      displayInColumn: false,
    },
  }
];

export const testCaseTableMoreDetails: any = [
  {
    display_name: "Test Type",
    key: "testCaseType",
  },
  {
    display_name: "Sub Type",
    key: "subType",
  },
  {
    display_name: "Traceability",
    key: "traceability"
  },
  {
    display_name: "Prerequisites",
    key: "prerequisites"
  },
  {
    display_name: "Test Steps",
    key: "testScenario"
  },
  {
    display_name: "Expected Results",
    key: "expectedResult"
  },
  {
    display_name: "Feedback",
    key: "feedback",
    _config: {
      value: ['thumb_up', 'thumb_down']
    }
  }
];

export const testCaseVersionMoreDetails: any = [
  {
    display_name: "Story Id",
    key: "key",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Story",
    key: "storysummary",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Test Case ID",
    key: "testCaseId",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Test Case Description",
    key: "testCase",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Prerequisites",
    key: "prerequisites",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Test Steps",
    key: "testScenario",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Expected Results",
    key: "expectedResult",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  }
];

export const testCaseTableData: any = [
  {
    testCaseId: "TC_01",
    userStoryId: "ST_01",
    path: "Lorem ipsum> dolor sit> amet, consectetur >adipiscing>Lorem ipsum",
    testType: "Regression",
    subType: "Functional",
    testScenario: "Simplify opportunity creation from leads",
    expectedResult: [
      "Login page is displayed",
      "Fields accept input without error",
    ],
    testSteps: ["Open the login page of the application"],
    prerequisites: [
      "User is registered with a valid email and password.",
      "User is on the application’s login page.",
    ],
  },
  {
    testCaseId: "TC_02",
    userStoryId: "ST_01",
    path: "Lorem ipsum> dolor sit> amet, consectetur >adipiscing>Lorem ipsum",
    testType: "Regression",
    subType: "Functional",
    testScenario: "Enable Advanced Search Filters for Product Listings...",
    expectedResult: [
      "Login page is displayed",
      "Fields accept input without error",
      "User is authenticated and redirected to the dashboard",
    ],
    testSteps: ["Open the login page of the application"],
    prerequisites: [
      "User is registered with a valid email and password.",
      "User is on the application’s login page.",
    ],
  },
  {
    testCaseId: "TC_03",
    userStoryId: "ST_01",
    path: "Lorem ipsum> dolor sit> amet, consectetur >adipiscing>Lorem ipsum",
    testType: "Regression",
    subType: "Functional",
    testScenario: "Simplify opportunity creation from leads",
    expectedResult: ["User’s name and data are displayed on the dashboard"],
    testSteps: ["Open the login page of the application"],
    prerequisites: [
      "Internet connection is active.",
      "User is registered with a valid email and password.",
      "User is on the application’s login page.",
    ],
  },
];

export const userStoriesTableColumns: any = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
      borderRadius: "6px 0 0",
      width: "7%",
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
  },
  {
    display_name: "Story ID",
    key: "storyId",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
    _config: {
      type: "row-click",
      isClickable: "true",
      displayInColumn: false
    },
  },
  {
    display_name: "Title",
    key: "summary",
    headerStyles: {
      background: "#7593F2",
      width: "40%"
    },
    _config: {
      type: "row-click",
      isClickable: "true",
      displayInColumn: false
    },
  },
  {
    display_name: "RCI",
    key: "rciScore",
    headerStyles: {
      background: "#7593F2",
      // width: "45%",
      borderRadius: "0 6px 0 0",
    },
    _config: {
      type: "rank",
      displayInColumn: false,
      enableFilter: true,
      filter: {
        type: 'rci'
      },
      errorIf: {
        targetKey: 'rciStatus',
        notValue: 'COMPLETED'
      }
    }
  }
];

export const userStoriesMoreDetails: any = [
  {
    display_name: "Story",
    key: "summary",
    _config: {
      type: "row-click",
      isClickable: "true",
      isBold: true,
    },
  },
  {
    display_name: "Story ID",
    key: "storyId",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Story Description",
    key: "description",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "Acceptance Criteria",
    key: "acceptanceCriteria",
    _config: {
      type: "row-click",
      isClickable: "true",
    },
  },
  {
    display_name: "RCI",
    key: "rciScore",
    _viewType: 'rank'
  },
  {
    display_name: "Quality Report",
    key: "qualityReportId",
    _config: {
      type: "row-click",
      isClickable: "true"
    }
  }
];
